// Need to map the fields to match the ones used by the recommendation library
// Used for collections, autocomplete and search
export default (response) => {
  response?.products?.hits.forEach((product) => {
    product.product_id = product.productId;
    product.price_currency_code = product.priceCurrencyCode || 'USD';
    product.list_price = product.listPrice || 0;
    product.list_price_text = String(product.list_price.toFixed(2));
    product.price_text = String(product.price.toFixed(2));
    product.image_url = product.imageUrl || '';
    product.alternate_image_urls = product.alternateImageUrls || [];
    product.date_published = product.datePublished || 0;
    // product.custom_fields = product.customFields || null;
    product.custom_fields = product?.customFields?.reduce((acc, customField) => {
      if (customField.key === 'producttype') {
        acc['productType'] = customField.value;
      } else {
        acc[customField.key] = customField.value;
      }
      return acc;
    }, {}),

    delete product.productId;
    delete product.priceCurrencyCode;
    delete product.listPrice;
    delete product.imageUrl;
    delete product.alternateImageUrls;
    delete product.datePublished;
    delete product.customFields;

    // Variants
    product.skus = product.skus.map((sku) => {
      return {
        name: sku.name,
        id: sku.id,
        available: true,
        image_url: sku.imageUrl,
        price: sku.price,
        custom_fields: sku?.customFields?.reduce((acc, customField) => {
          if (customField.key === 'size' || customField.key === 'color') {
            acc[customField.key.charAt(0).toUpperCase() + customField.key.slice(1)] = customField.value;
          } else if (customField.key === 'skucode') {
            acc['skuCode'] = customField.value;
          } else {
            acc[customField.key] = customField.value;
          }
          return acc;
        }, {}),
      };
    }) || [];
  });

  return response;
};
